// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api/v1",
  timeout: 3000000,
});

// interceptor para agregar token en cada request
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token"); // ⚡ siempre tomamos de sessionStorage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
